module.exports = __webpack_public_path__ + "img/icono-15-1.b2d0f1af.png";